import { createContext, Dispatch, SetStateAction } from "react";

export type ContextProps = {
    acessToken: string;
    setAcessToken: Dispatch<SetStateAction<string>>;
    validToken: boolean;
    setValidToken: Dispatch<SetStateAction<boolean>>;
    openMenu: boolean;
    setOpenMenu: Dispatch<SetStateAction<boolean>>;
};

const Context = createContext({} as ContextProps);

export default Context;
